const headers = {
  name: "Billing Returns",
  components: [
    {
      type: "search",
      name: "search",
      placeholder: "Search",
      value: "",
    },
    {
      type: "select",
      name: "sort",
      placeholder: "Sort",
      allowClear: true,
      showSearch: false,
      filterOption: true,
      value: null,
      options: [
        { value: 0, label: "Price (Low-High)" },
        { value: 1, label: "Price (High-Low)" },
      ],
    },
    {
      type: "filter",
      name: "customer",
      allowClear: true,
      showSearch: true,
      filterOption: false,
      placeholder: "Customer",
      api: "get-all-customers",
      value: null,
      options: null,
    },
    {
      type: "filter",
      name: "status",
      placeholder: "Status",
      value: null,
      allowClear: true,
      showSearch: false,
      filterOption: true,
      options: [
        { value: 0, label: "Inactive" },
        { value: 1, label: "Active" },
      ],
    },
    {
      type: "range",
      name: "date",
      value: {
        start: "",
        end: "",
      },
    },
    // {
    //   type: "range",
    //   name: "due_date",
    //   value: {
    //     start: "",
    //     end: "",
    //   },
    // },
    {
      type: "add",
      path: "/app/billing/returns/add",
    },
  ],
  navigate: {
    tabs: [
      {
        name: "Billings",
        path: "/app/billing",
      },
      {
        name: "Returns",
        path: "",
      },
      {
        name: "Sessions",
        path: "/app/billing/session",
      },
      /*   {
          name: "Quotes",
          path: "/app/sales/quotes",
        }, 
       {
          name: "Boqs",
          path: "/app/sales/boqs",
        }, */
    ],
    total: [
      { value: 0, label: "Total" },
      { value: 0, label: "Active" },
      { value: 0, label: "Inactive" },
    ],
  },
};

export default headers;
